import {dateFilterParams} from '../../views/components/ag-grid/filter-params/DateComparator';

export default [
  {
    headerName: 'SubmissionDate',
    headerClass: 'header-text-wrap',
    field: 'SubmissionDate',
    tooltipField: 'SubmissionDate',
    tooltipComponentParams: { field: 'SubmissionDate', isDate: true },
    filter: 'agDateColumnFilter',
    minWidth: 100,
    cellRenderer: 'CellRendererDate',
    filterParams: dateFilterParams,
  },
  {
    headerName: 'Distributor',
    headerClass: 'header-text-wrap',
    field: 'Distributor',
    tooltipField: 'Distributor',
    tooltipComponentParams: { field: 'Distributor' },
    filter: 'agTextColumnFilter',
    minWidth: 150,
  },
  {
    headerName: 'Action',
    tooltipField: 'Action',
    // tooltipComponentParams: { field: 'QuoteURL' },
    cellRenderer: 'CellRendererApiButton',
    cellClass: 'flex justify-start',
    minWidth: 95,
    // maxWidth: 81,
    cellRendererParams(params) {
      return {
        column: 'QuoteURL',
        itemId: params.data.Policy_PK,
        buttonTxt: params.data.ActionNameText || 'Action',
        active: params.data.EnableAction,
        backGroundColour: params.data.BtnBkGround,
        borderColour: params.data.BtnBorder,
        fontColour: params.data.BtnFontClr,
        confirmAction: params.data.ConfirmAction,
        confirmActionMessage: params.data.ConfirmActionMessage,
      }
    },
  },
  {
    headerName: 'Status',
    headerClass: 'header-text-wrap',
    field: 'Status',
    tooltipField: 'Status',
    tooltipComponentParams: { field: 'Status' },
    filter: 'agSetColumnFilter',
    minWidth: 150,
  },
  {
    headerName: 'CertificatePolicyNo',
    headerClass: 'header-text-wrap',
    field: 'CertificatePolicyNo',
    tooltipField: 'CertificatePolicyNo',
    tooltipComponentParams: { field: 'CertificatePolicyNo'},
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
  {
    headerName: 'UniqueIdentifier',
    headerClass: 'header-text-wrap',
    field: 'Identifier',
    tooltipField: 'Identifier',
    tooltipComponentParams: { field: 'Identifier' },
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
  {
    headerName: 'InceptionDate',
    headerClass: 'header-text-wrap',
    field: 'InceptionDate',
    tooltipField: 'InceptionDate',
    tooltipComponentParams: { field: 'InceptionDate', isDate: true  },
    filter: 'agDateColumnFilter',
    minWidth: 100,
    cellRenderer: 'CellRendererDate',
    filterParams: dateFilterParams,
  },
  {
    headerName: 'ExpiryDate',
    headerClass: 'header-text-wrap',
    field: 'ExpiryDate',
    tooltipField: 'ExpiryDate',
    tooltipComponentParams: { field: 'ExpiryDate', isDate: true },
    filter: 'agDateColumnFilter',
    minWidth: 100,
    cellRenderer: 'CellRendererDate',
    filterParams: dateFilterParams,
  },
  {
    headerName: 'FirstName',
    headerClass: 'header-text-wrap',
    field: 'InsuredFirstName',
    tooltipField: 'InsuredFirstName',
    tooltipComponentParams: { field: 'InsuredFirstName' },
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
  {
    headerName: 'Surname',
    headerClass: 'header-text-wrap',
    field: 'InsuredSurname',
    tooltipField: 'InsuredSurname',
    tooltipComponentParams: { field: 'InsuredSurname' },
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
  {
    headerName: 'CompanyName',
    headerClass: 'header-text-wrap',
    field: 'InsuredCompanyName',
    tooltipField: 'InsuredCompanyName',
    tooltipComponentParams: { field: 'InsuredCompanyName' },
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
  {
    headerName: 'Producer',
    headerClass: 'header-text-wrap',
    field: 'ProducerCompanyName',
    tooltipField: 'ProducerCompanyName',
    tooltipComponentParams: { field: 'ProducerCompanyName' },
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
  {
    headerName: 'ProducerCode',
    headerClass: 'header-text-wrap',
    field: 'ProducerCompanyCode',
    tooltipField: 'ProducerCompanyCode',
    tooltipComponentParams: { field: 'ProducerCompanyCode' },
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
  {
    headerName: 'InsuredFiscalCode',
    headerClass: 'header-text-wrap',
    field: 'InsuredFiscalCode',
    tooltipField: 'InsuredFiscalCode',
    tooltipComponentParams: { field: 'InsuredFiscalCode' },
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
  {
    headerName: 'InsuredVATCode',
    headerClass: 'header-text-wrap',
    field: 'InsuredVATCode',
    tooltipField: 'InsuredVATCode',
    tooltipComponentParams: { field: 'InsuredVATCode' },
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
  {
    headerName: 'Profession',
    headerClass: 'header-text-wrap',
    field: 'Profession',
    tooltipField: 'Profession',
    tooltipComponentParams: { field: 'Profession' },
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
  {
    headerName: 'AddressLine1',
    headerClass: 'header-text-wrap',
    field: 'AddressLine1',
    tooltipField: 'AddressLine1',
    tooltipComponentParams: { field: 'AddressLine1' },
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
  {
    headerName: 'LimitOfIndemnity',
    headerClass: 'header-text-wrap',
    field: 'LimitOfIndemnity',
    tooltipField: 'LimitOfIndemnity',
    tooltipComponentParams: { field: 'LimitOfIndemnity' },
    filter: 'agNumberColumnFilter',
    minWidth: 200,
    tooltipComponentParams: {
      field: 'LimitOfIndemnity',
      showCurrency: true,
    },
    cellRenderer: 'CellRendererMasterValue',
    cellRendererParams(params) {
      return {
        unit: '€',
        unitPosition: 'start',
        returnFloat: true,
      }
    },
  },
  {
    headerName: 'FinalPremium',
    headerClass: 'header-text-wrap',
    field: 'FinalPremium',
    tooltipField: 'FinalPremium',
    tooltipComponentParams: { field: 'FinalPremium' },
    filter: 'agNumberColumnFilter',
    minWidth: 200,
    tooltipComponentParams: {
      field: 'FinalPremium',
      showCurrency: true,
    },
    cellRenderer: 'CellRendererMasterValue',
    cellRendererParams(params) {
      return {
        unit: '€',
        unitPosition: 'start',
        returnFloat: true,
      }
    },
  },
  {
    headerName: 'User',
    headerClass: 'header-text-wrap',
    field: 'SubmitterName',
    tooltipField: 'SubmitterName',
    tooltipComponentParams: { field: 'SubmitterName' },
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
];

